// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isTranslatablePresentation, translateFromPresentation } from "@sequentech/ui-core";
var isResultsJson = function (value) {
    if (value === null ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean") {
        return true;
    }
    if (Array.isArray(value)) {
        return value.every(isResultsJson);
    }
    return typeof value === "object" && Object.values(value).every(isResultsJson);
};
export var parseMaybeJson = function (value) {
    if (typeof value !== "string") {
        return value;
    }
    try {
        var parsed = JSON.parse(value);
        return isResultsJson(parsed) ? parsed : value;
    }
    catch (_a) {
        return value;
    }
};
export var translatedLabel = function (row, locale, fallback) {
    if (fallback === void 0) { fallback = "-"; }
    if (!row) {
        return fallback;
    }
    var parsedPresentation = parseMaybeJson(row.presentation);
    var presentation = isTranslatablePresentation(parsedPresentation)
        ? parsedPresentation
        : undefined;
    var translated = translateFromPresentation(__assign(__assign({}, row), { presentation: presentation }), "name", locale);
    return typeof translated === "string" && translated.length ? translated : fallback;
};
export var manifestTitle = function (title, locale, fallback) {
    var _a, _b;
    if (typeof title === "string") {
        return title;
    }
    return (_b = (_a = title === null || title === void 0 ? void 0 : title[locale]) !== null && _a !== void 0 ? _a : title === null || title === void 0 ? void 0 : title.en) !== null && _b !== void 0 ? _b : fallback;
};
